var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3718 1.60301C59.3746 2.55208 59.4182 4.13439 58.4691 5.1372L50.2364 13.836C58.2816 23.1635 58.6953 36.9163 51.2467 46.7083L59.8369 54.8382C60.8397 55.7873 60.8832 57.3696 59.9341 58.3724C58.9851 59.3752 57.4028 59.4188 56.3999 58.4697L47.8566 50.3841C38.4842 58.7949 24.4001 59.2928 14.4638 51.634L6.69996 59.8373C5.75089 60.8401 4.16858 60.8837 3.16577 59.9346C2.16296 58.9855 2.1194 57.4032 3.06848 56.4004L10.8096 48.221C2.39145 38.7198 2.03476 24.4588 9.99027 14.5467L1.69982 6.70052C0.697017 5.75144 0.653459 4.16913 1.60253 3.16632C2.55161 2.16352 4.13392 2.11996 5.13673 3.06903L13.4741 10.9596C22.93 2.9082 36.8565 2.63422 46.6276 10.3752L54.8376 1.7003C55.7867 0.69749 57.369 0.653932 58.3718 1.60301ZM13.637 17.9981C7.55845 25.8816 7.82929 36.9948 14.2633 44.5718L27.2341 30.8666L13.637 17.9981ZM30.671 27.2351L17.1321 14.4217C24.6531 8.34563 35.4367 8.1553 43.1739 14.0244L30.671 27.2351ZM30.8656 34.3035L17.9229 47.979C25.8226 53.768 36.7614 53.3593 44.2099 46.9328L30.8656 34.3035ZM47.5886 43.2462L34.3025 30.672L46.7772 17.491C52.8473 24.8839 53.1736 35.4969 47.5886 43.2462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.597fda6b9c7831255eb595e47341ae23.svg";
export { ForwardRef as ReactComponent };